import { render } from "./crm-leads.vue?vue&type=template&id=551f7ec8&scoped=true"
import script from "./crm-leads.vue?vue&type=script&lang=js"
export * from "./crm-leads.vue?vue&type=script&lang=js"

import "./crm-leads.vue?vue&type=style&index=0&id=551f7ec8&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"
import "./crm-leads.vue?vue&type=style&index=2&id=551f7ec8&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551f7ec8"]])

export default __exports__